import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { navigateToMarketingSite } from '../../utils/marketingNavigation';

type MarketingRedirectProps = {
  to?: string;
};

/** Sends the browser to peppar-site instead of rendering legacy React marketing pages. */
const MarketingRedirect: React.FC<MarketingRedirectProps> = ({ to }) => {
  const location = useLocation();
  const dest = to || `${location.pathname}${location.search || ''}`;

  useEffect(() => {
    navigateToMarketingSite(dest);
  }, [dest]);

  return (
    <div style={{ padding: '48px 24px', textAlign: 'center', color: '#6b7280' }}>
      Redirecting…
    </div>
  );
};

export default MarketingRedirect;
